import React, { Component } from 'react'
import Errordialog from '../Common/ErrorDialog/ErrorDialog.jsx'
class ErrorBoundary extends Component {
    constructor(props) {
        super(props)

        this.state = {
            hasError: false
        }
    }
    

    static getDerivedStateFromError(error) {
        console.error('error occureed',error);
        return {
            hasError: true
        }
    }

    

    render() {
        
        if (this.state.hasError) {
            return (
                <React.Fragment>

                    <Errordialog
                        open 
                        isErrorBoundry/>
                </React.Fragment>
            )
        }
        return this.props.children
    }
}

export default ErrorBoundary;
